import React, { useEffect, useState, useContext, useRef, useCallback, useMemo } from 'react';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { useNavigate, useLocation } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { CiCircleCheck } from "react-icons/ci";
import InputMask from "react-input-mask";
import { PhoneInput } from 'react-international-phone';
import cep from 'cep-promise';

import api from '../../services/api';
import countriesJson from '../../json/countries.json';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CardForm from '../../components/CardForm';
import Card from '../../components/Card';

import LanguageContext from '../../contexts/language';
import AuthContext from '../../contexts/auth';

const initialCardState = {
    cardNumber: '#### #### #### ####',
    cardHolder: 'NOME COMPLETO',
    cardMonth: '',
    cardYear: '',
    cardCvv: '',
    isCardFlipped: false
};

/* Stripe */
const pk_stripe = 'pk_live_51Sf1eCAykGGgDhfqijsvVHRj5phPEzIhpKj1CBiOMU3VugsKH2bMeMmDplHdTDloQ71m4fiv5fqrkJfv4B1DwhQM00FpLi6lyD';
const promise = loadStripe(pk_stripe, {locale: localStorage.getItem('language')==='pt' ? 'pt-BR' : localStorage.getItem('language')==='es' ? 'es' : 'en' });
/* Stripe */

export default function Inscricao() {

    const { signed } = useContext(AuthContext);
    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');
    const stripeToken = localStorage.getItem('stripe_id');
    const [stripe_id, setStripeId] = useState(stripeToken);

    const [card_state, setCardState] = useState(initialCardState);
    const [currentFocusedElm, setCurrentFocusedElm] = useState(null);

    const location = useLocation();
    const isVip = location.pathname === '/inscricao-vip';

    const updateStateValues = useCallback(
        (keyName, value) => {
            setCardState({
                ...card_state,
                [keyName]: value || initialCardState[keyName]
            });
        },
        [card_state]
    );

    const navigate = useNavigate();

    const [page, setPage] = useState(0);

    const [loading, setLoading] = useState(false);
    const [loading_total, setLoadingTotal] = useState(false);
    const [error, setError] = useState(false);
    const [error_message, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);

    const [name, setName] = useState('');
    const [name_badge, setNameBadge] = useState('');
    const [email, setEmail] = useState('');
    const [document, setDocument] = useState('');
    const [validate_CPF, setValidateCPF] = useState(false);

    const [phone, setPhone] = useState('');
    const phone_country = lang==='pt' ? 'br' : 'us';
    const [member, setMember] = useState('no');
    const [member_tustin, setMemberTustin] = useState('no');

    const [zipcode, setZipcode] = useState('');
    const [address, setAddress] = useState('');
    const [number, setNumber] = useState(' ');
    const [neighborhood, setNeighborhood] = useState('');
    const [complement, setComplement] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [cep_error, setCepError] = useState(false);
    const [cep_success, setCepSuccess] = useState(false);
    const [cep_error_message, setCepErrorMessage] = useState('');
    
    const [country, setCountry] = useState('');
    const [pre_prefer_1, setPrePrefer1] = useState('');
    const [pre_prefer_2, setPrePrefer2] = useState('');
    const [pre_prefer_3, setPrePrefer3] = useState('');
    const [case_pre_opt, setCasePreOpt] = useState('no');
    const [case_pre_type, setCasePreType] = useState('');

    const [prefer_1, setPrefer1] = useState('');
    const [prefer_2, setPrefer2] = useState('');
    const [prefer_3, setPrefer3] = useState('');
    
    const [case_opt, setCaseOpt] = useState('no');
    const [case_type, setCaseType] = useState('');

    const [category, setCategory] = useState('');
    const [pre_conference, setPreConference] = useState('no');
    const [pre_conference_total, setPreConferenceTotal] = useState(0);
    const [dinner, setDinner] = useState('no');
    const [dinner_person, setDinnerPerson] = useState('1');
    const [dinner_name, setDinnerName] = useState('');
    const [dinner_total, setDinnerTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalCents, setTotalCents] = useState(0);
    const [currency, setCurrency] = useState(null);

    const nameInput = useRef(null);
    const nameBadgeInput = useRef(null);
    const emailInput = useRef(null);
    const documentInput = useRef(null);
    const phoneInput = useRef(null);
    const countryInput = useRef(null);
    const categoryInput = useRef(null);

    const prePrefer1Input = useRef(null);
    const prePrefer2Input = useRef(null);
    const prePrefer3Input = useRef(null);
    const casePreTypeInput = useRef(null);

    const prefer1Input = useRef(null);
    const prefer2Input = useRef(null);
    const prefer3Input = useRef(null);
    const caseTypeInput = useRef(null);

    const dinnerNameInput = useRef(null);

    const countries = useMemo(() => {
        return [...countriesJson].sort((a, b) => {
            if (lang === 'pt') {
                return (a.nome || '').localeCompare(b.nome || '', 'pt-BR');
            }else if (lang === 'es') {
                return (a.nome_es || '').localeCompare(b.nome_es || '', 'es');
            }

            return (a.nome_en || '').localeCompare(b.nome_en || '', 'en');
        });
    }, [lang]);

    function clearMessage(){
        setError(false);
        setErrorMessage('');
        setSuccess(false);
    }

    function changePreConference(opt){
        setPreConference(opt);
        if(opt==="no"){
            setPrePrefer1('');
            setPrePrefer2('');
            setPrePrefer3('');
        }
    }

    function changeCategory(opt){
        setCategory(opt);
        if(opt!="0"){
            setMemberTustin('no');
            setMember('no');
        }
    }

    function changePhoneCountry(country){
        phoneInput.current.setCountry(country);
    }

    function ValidateCPF(value) {
        if(value==null){
            var cpf = '';
        }else{
            value = value.replace('.','');
            value = value.replace('.','');
            value = value.replace('_', '');
            var cpf = value.replace('-','');
        }
    
    
        while(cpf.length < 11) cpf = "0"+ cpf;
        var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
        var a = [];
        var b = new Number;
        var c = 11;
        var i, x, y;
        for (i=0; i<11; i++){
            a[i] = cpf.charAt(i);
            if (i < 9) b += (a[i] * --c);
        }
        if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11-x }
        b = 0;
        c = 11;
        for (y=0; y<10; y++) b += (a[y] * c--);
        if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11-x; }
        
        var has_return = true;
        if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) has_return = false;
        
        return has_return;
    }

    function changeValidateCPF(value){
        setDocument(value);
        setValidateCPF(ValidateCPF(value));
    }

    function searchZipcode(value) {

        if(value==""){
            return false;
        }
        const counter = value.replace(/_/ig, '');
        if(counter.length===9){
            cep(value).then(function (response) {
                setAddress(response.street);
                setNeighborhood(response.neighborhood);
                setCity(response.city);
                setState(response.state);
                setCepSuccess(true);
                setCepError(false);
                setCepErrorMessage('');
            }).catch(function (error) {
                setCepSuccess(false);
                setCepError(true);
                setCepErrorMessage(error.message);
            });
        }
    }

    function zipcodeDigit(value){
        setZipcode(value);
    }

    async function sendRegister(e){
        if(e){
            e.preventDefault();
        }
        setLoading(true);
        setSuccess(false);

        try{
            const response = await api.post(`/register`, {
                lang,
                currency,
                name,
                name_badge,
                email,
                phone,
                document,
                country,
                category,
                member,
                member_tustin,
                pre_conference,
                pre_conference_total,
                pre_prefer_1,
                pre_prefer_2,
                pre_prefer_3,
                case_pre_opt,
                case_pre_type,
                prefer_1,
                prefer_2,
                prefer_3,
                case_opt,
                case_type,
                dinner,
                dinner_person,
                dinner_name,
                dinner_total,
                total,
                zipcode,
                address,
                number,
                complement,
                neighborhood,
                city,
                state,
            });

            if(response.data.status==="success"){
                if(total>0){
                    if(currency === 'BRL'){
                        submitPagarme()
                        return;
                    }else{
                        submitStripe()
                        return;
                    }
                }else{
                    setLoading(false);
                    setError(false);
                    setErrorMessage('');
                    setSuccess(true);
                    localStorage.removeItem("stripe_id");
                }
            }else{
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_email);
                setSuccess(false);
            }
        }catch(err){
            setLoading(false);
            setError(true);
            setErrorMessage(err.message);
            setSuccess(false);
        }
    }

    async function submitPagarme(){

        setLoading(true);
        setSuccess(false);

        let card_expiration_year = card_state.cardYear.substring(2);
        let card_number = card_state.cardNumber;
        let card_cvv = card_state.cardCvv;
        let card_expiration_date = `${card_state.cardMonth}${card_expiration_year}`;
        let card_holder_name = card_state.cardHolder;

        if(card_number=="" || card_holder_name=="" || card_state.cardMonth=="" || card_state.cardYear=="" || card_cvv==""){
            setLoading(false);
            setError(true);
            setErrorMessage("Preencha os dados do cartão!");
            setSuccess(false);
            return;
        }

        try{
            const response = await api.post(`/payment`, {
                lang,
                currency,
                name,
                name_badge,
                email,
                phone,
                document,
                country,
                category,
                member,
                member_tustin,
                pre_conference,
                pre_conference_total,
                pre_prefer_1,
                pre_prefer_2,
                pre_prefer_3,
                case_pre_opt,
                case_pre_type,
                prefer_1,
                prefer_2,
                prefer_3,
                case_opt,
                case_type,
                dinner,
                dinner_person,
                dinner_name,
                dinner_total,
                total,
                zipcode,
                address,
                number,
                complement,
                neighborhood,
                city,
                state,
                card_number,
                card_cvv,
                card_expiration_date,
                card_holder_name,
            });

            if(response.data.status=="error"){
                setLoading(false);
                setError(true);
                setErrorMessage(response.data.message);
                setSuccess(false);
                return;
            }else if(response.data.status=="paid"){
                setLoading(false);
                setError(false);
                setErrorMessage('');
                setSuccess(true);
                localStorage.removeItem("stripe_id");
            }else if(response.data.status=="canceled" || response.data.status=="refused"){
                setLoading(false);
                setError(true);
                setErrorMessage('Transação recusada pelo emissor do cartão.');
                setSuccess(false);
            }else if(response.data.status=="processing" || response.data.status=="authorized" || response.data.status=="waiting_payment"){
                setLoading(false);
                setError(false);
                setErrorMessage('');
                setSuccess(true);
                localStorage.removeItem("stripe_id");
            }
        }catch(error){
            setLoading(false);
            setError(true);
            setErrorMessage(error.message);
            setSuccess(false);
            return;
        }
    }

    async function submitStripe(){

        setLoading(true);
        setSuccess(false);

        try{
            const response = await api.post(`/payment-stripe`, {
                lang,
                currency,
                name,
                name_badge,
                email,
                phone,
                document,
                country,
                category,
                member,
                member_tustin,
                pre_conference,
                pre_conference_total,
                pre_prefer_1,
                pre_prefer_2,
                pre_prefer_3,
                case_pre_opt,
                case_pre_type,
                prefer_1,
                prefer_2,
                prefer_3,
                case_opt,
                case_type,
                dinner,
                dinner_person,
                dinner_name,
                dinner_total,
                total,
                zipcode,
                address,
                number,
                complement,
                neighborhood,
                city,
                state,
                stripe_id
            });

            if(response.data.status=="error"){
                setLoading(false);
                setError(true);
                setErrorMessage(response.data.message);
                setSuccess(false);
                return;
            }
            
            setLoading(false);
            setError(false);
            setErrorMessage('');
            setSuccess(true);
            localStorage.removeItem("stripe_id");
        }catch(error){
            setLoading(false);
            setError(true);
            setErrorMessage(error.message);
            setSuccess(false);
            return;
        }
    }

    function next(page){
        if(page===1){
            if(name.trim() === ''){
                nameInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(name_badge.trim() === ''){
                nameBadgeInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(email.trim() === ''){
                emailInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(country.trim() === ''){
                countryInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(phone.trim() === ''){
                phoneInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(document.trim() === ''){
                if(category==='2' || category==='5' || country==='BRA'){
                }else{
                    documentInput.current.focus();
                }
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(category.trim() === ''){
                categoryInput.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(category==='2' || category==='5' || country==='BRA'){
                if(!validate_CPF){
                    setLoading(false);
                    setError(true);
                    setErrorMessage('CPF inválido!');
                    return;
                }
            }
        }else if(page===2){
            if(pre_conference.trim() === 'yes'){
                if(pre_prefer_1.trim() === ''){
                    prePrefer1Input.current.focus();
                    setLoading(false);
                    setError(true);
                    setErrorMessage(language.error_input);
                    return;
                }else if(pre_prefer_2.trim() === ''){
                    prePrefer2Input.current.focus();
                    setLoading(false);
                    setError(true);
                    setErrorMessage(language.error_input);
                    return;
                }else if(pre_prefer_3.trim() === ''){
                    prePrefer3Input.current.focus();
                    setLoading(false);
                    setError(true);
                    setErrorMessage(language.error_input);
                    return;
                }else if(case_pre_opt.trim() === 'yes'){
                    if(case_pre_type.trim() === ''){
                        casePreTypeInput.current.focus();
                        setLoading(false);
                        setError(true);
                        setErrorMessage(language.error_input);
                        return;
                    }
                }
            }
        }else if(page===3){
            if(prefer_1.trim() === ''){
                prefer1Input.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(prefer_2.trim() === ''){
                prefer2Input.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(prefer_3.trim() === ''){
                prefer3Input.current.focus();
                setLoading(false);
                setError(true);
                setErrorMessage(language.error_input);
                return;
            }else if(case_opt.trim() === 'yes'){
                if(case_type.trim() === ''){
                    caseTypeInput.current.focus();
                    setLoading(false);
                    setError(true);
                    setErrorMessage(language.error_input);
                    return;
                }
            }
        }else if(page===4){
            if(dinner_person.trim() === '2'){
                if(dinner_name.trim() === ''){
                    dinnerNameInput.current.focus();
                    setLoading(false);
                    setError(true);
                    setErrorMessage(language.error_input);
                    return;
                }
            }
        }

        setPage(page + 1);
        scrollToTop();
    }

    function prev(page){
        setPage(page - 1);
        scrollToTop();
    }

    let formFieldsRefObj = {
        cardNumber: useRef(),
        cardHolder: useRef(),
        cardDate: useRef(),
        cardCvv: useRef()
    };

    let focusFormFieldByKey = useCallback((key) => {
        formFieldsRefObj[key].current.focus();
    });

    let cardElementsRef = {
        cardNumber: useRef(),
        cardHolder: useRef(),
        cardDate: useRef()
    };

    let onCardFormInputFocus = (_event, inputName) => {
        const refByName = cardElementsRef[inputName];
        setCurrentFocusedElm(refByName);
    };

    let onCardInputBlur = useCallback(() => {
        setCurrentFocusedElm(null);
    }, []);

    const EARLY_BIRD_LIMIT = new Date('2026-04-16');

    function getPeriod() {
        return new Date() <= EARLY_BIRD_LIMIT ? 'early' : 'late';
    }

    const CATEGORY_PRICES = {
        0: {
            early: { value: 0, currency: country==='BRA' ? 'BRL' : 'EUR' },
            late:  { value: 0, currency: country==='BRA' ? 'BRL' : 'EUR' }
        },
        1: {
            early: { value: 215, currency: 'EUR' },
            late:  { value: 275, currency: 'EUR' }
        },
        2: {
            early: { value: 1375, currency: 'BRL' },
            late:  { value: 1630, currency: 'BRL' }
        },
        3: {
            early: { value: 290, currency: 'EUR' },
            late:  { value: 350, currency: 'EUR' }
        },
        4: {
            early: { value: 240, currency: 'EUR' },
            late:  { value: 300, currency: 'EUR' }
        },
        5: {
            early: { value: 1530, currency: 'BRL' },
            late:  { value: 1780, currency: 'BRL' }
        },
        6: {
            early: { value: 320, currency: 'EUR' },
            late:  { value: 390, currency: 'EUR' }
        }
    };

    const PRE_CONFERENCE_PRICES = {
        member: {
            BRL: 190,
            EUR: 27
        },
        not: {
            EUR: 30
        }
    };

    const DINNER_PRICES = {
        EUR: 65,
        BRL: 380
    };

    function calculateTotal(category, pre_conference, dinner, dinner_person, member_tustin) {

        const period = getPeriod();
        const categoryData = CATEGORY_PRICES[category]?.[period];

        if (!categoryData) return null;

        let totalValue = categoryData.value;
        let currency = categoryData.currency;
        let totalDinner = 0;
        let totalPreConference = 0;

        if (pre_conference === 'yes') {
            if (currency === 'BRL') {
                totalValue += PRE_CONFERENCE_PRICES.member.BRL;
                totalPreConference = PRE_CONFERENCE_PRICES.member.BRL;
            } else {
                if(category==='0'){
                    totalValue += member==='yes' ? PRE_CONFERENCE_PRICES.member.EUR : PRE_CONFERENCE_PRICES.not.EUR;
                    totalPreConference = member==='yes' ? PRE_CONFERENCE_PRICES.member.EUR : PRE_CONFERENCE_PRICES.not.EUR;
                }else{
                    totalValue += (category==='1' || category==='3') ? PRE_CONFERENCE_PRICES.member.EUR : PRE_CONFERENCE_PRICES.not.EUR;
                    totalPreConference = (category==='1' || category==='3') ? PRE_CONFERENCE_PRICES.member.EUR : PRE_CONFERENCE_PRICES.not.EUR;
                }
            }
        }

        if(category==='0' && member_tustin=='yes'){
            let discount = totalValue * 0.10;
            totalValue = totalValue - discount;
            totalPreConference = totalPreConference - discount;
        }

        if (dinner === 'yes') {
            if (currency === 'BRL') {
                totalValue += dinner_person==='1' ? DINNER_PRICES.BRL : 2 * DINNER_PRICES.BRL;
                totalDinner = dinner_person==='1' ? DINNER_PRICES.BRL : 2 * DINNER_PRICES.BRL;
            } else {
                totalValue += dinner_person==='1' ? DINNER_PRICES.EUR : 2 * DINNER_PRICES.EUR;
                totalDinner = dinner_person==='1' ? DINNER_PRICES.EUR : 2 * DINNER_PRICES.EUR;
            }
        }

        const totalCents = Math.round(totalValue * 100);

        return { totalValue, totalCents, currency, period, totalDinner, totalPreConference };
    }

    function formatCurrency(value, currency = 'BRL', locale = currency === 'BRL' ? 'pt-BR' : 'en-US') {
        if (value === null || value === undefined) return '';
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
        });
        return formatter.formatToParts(value).map(part =>part.type === 'currency' ? part.value + ' ' : part.value).join('');
    }

    useEffect(() => {
        const result = calculateTotal(category, pre_conference, dinner, dinner_person, member_tustin);

        if (result) {
            setTotal(result.totalValue);
            setTotalCents(result.totalCents);
            setCurrency(result.currency);
            setDinnerTotal(result.totalDinner);
            setPreConferenceTotal(result.totalPreConference)
        } else {
            setTotal(0);
            setTotalCents(0);
            setCurrency(null);
            setDinnerTotal(0);
            setPreConferenceTotal(0)
        }
    }, [country, category, pre_conference, dinner, dinner_person, member, member_tustin]);

    const scrollToTop = () => {
        const content = window.document.getElementById("content-subscribe");
        content?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    const [user_total, setUserTotal] = useState('');
    const limit_total = 273;
    const limit_total_vip = 303;

    async function loadUserTotal(){
        setLoadingTotal(true);
        try{
            const response = await api.get(`/user-total`);
            setUserTotal(response.data.total);
            setLoadingTotal(false);
        }catch(err){
            setLoadingTotal(false);
        }
    }

    useEffect(() => {
        loadUserTotal();
    }, []);

    return (
        <div className="page">
            <Header />
            <div className="content" id="content-subscribe">
                <div className="full mt-30 mb-60">
                    <form onSubmit={sendRegister} className="form">
                        <h3 className="title_b color_4 mt-30 mb-30">
                            {language.menu_sub_inscricao}
                        </h3>

                        {success ?
                        <div className="content-card">
                            <div className="d-text">
                                <div className="w-100 message-success text-center pb-5">
                                    <CiCircleCheck />
                                    <strong>{language.success}</strong>
                                </div>
                                <table className="w-100">
                                    <tbody>
                                        {category==='0' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Membros do Conselho do Tustin Trust, Membros da Comissão Organizadora Brasileira, Palestrantes e Supervisores de Seminários Clínicos</p>}
                                                {lang==='es' &&<p>Miembros del Consejo del Tustin Trust, Miembros del Comité Organizador Brasileño, Conferencistas y Supervisores de Seminarios Clínicos</p>}
                                                {lang==='en' &&<p>Tustin Trust Board Members, Members of the Brazilian Organizational Committee, Lecturers and Supervisors of Clinical Seminars</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>{lang==='pt' ? 'Gratuito' : lang==='es' ? 'Gratis' : 'Free'}</strong></p>
                                            </td>
                                        </tr>}
                                        {category==='1' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Membros do FTMT da América Latina* / Leste Europeu / Índia**</p>}
                                                {lang==='es' &&<p>Miembros del FTMT de América Latina* / Europa del Este / India**</p>}
                                                {lang==='en' &&<p>FTMT Members from Latin America* / Eastern Europe / India**</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>€ 275.00</strong></p>
                                            </td>
                                        </tr>}
                                        {category==='2' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Membros do FTMT residentes no Brasil</p>}
                                                {lang==='es' &&<p>Miembros del FTMT residentes en Brasil</p>}
                                                {lang==='en' &&<p>FTMT Members residents in Brazil</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>R$ 1.630,00</strong></p>
                                            </td>
                                        </tr>}
                                        {category==='3' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Membros do FTMT de outros países</p>}
                                                {lang==='es' &&<p>Miembros del FTMT de otros países</p>}
                                                {lang==='en' &&<p>FTMT Members from any other countries</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>€ 350.00</strong></p>
                                            </td>
                                        </tr>}
                                        {category==='4' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Não Membros da América Latina* / Leste Europeu / Índia**</p>}
                                                {lang==='es' &&<p>No Miembros de América Latina* / Europa del Este / India**</p>}
                                                {lang==='en' &&<p>Non-Members from Latin America* / Eastern Europe / India**</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>€ 300.00</strong></p>
                                            </td>
                                        </tr>}
                                        {category==='5' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Não Membros residentes no Brasil</p>}
                                                {lang==='es' &&<p>No Miembros residentes en Brasil</p>}
                                                {lang==='en' &&<p>Non-Members residents in Brazil</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>R$ 1.780,00</strong></p>
                                            </td>
                                        </tr>}
                                        {category==='6' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Não Membros de outros países</p>}
                                                {lang==='es' &&<p>No Miembros de otros países</p>}
                                                {lang==='en' &&<p>Non-Members from any other countries</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>€ 390.00</strong></p>
                                            </td>
                                        </tr>}
                                        {pre_conference=='yes' &&
                                        <tr>
                                            <td>
                                                {lang==='pt' &&<p>Pré-Conferência</p>}
                                                {lang==='es' &&<p>Preconferencia</p>}
                                                {lang==='en' &&<p>Pre-Conference</p>}
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>{formatCurrency(pre_conference_total, currency)}</strong></p>
                                            </td>
                                        </tr>}
                                        {dinner=='yes' &&
                                        <tr>
                                            <td>
                                                <p>
                                                    {lang==='pt' ? 'Jantar Festivo (com música e dança)' : lang==='es' ? 'Cena Festiva (con música y baile)' : 'Festive Dinner (with music and dance)'} <strong>{dinner_person=='2' ? '2x' : ''}</strong>
                                                    {dinner_person=='2' &&
                                                    <>
                                                        <br />{lang==='pt' ? 'Segunda pessoa' : lang==='es' ? 'Segunda persona' : 'Second person'}: <strong>{dinner_name}</strong>
                                                    </>}
                                                </p>
                                            </td>
                                            <td width="120" className="text-end">
                                                <p><strong>{formatCurrency(dinner_total, currency)}</strong></p>
                                            </td>
                                        </tr>}
                                    </tbody>
                                </table>
                                <div className="w-100 d-flex align-items-center justify-content-center text-center mt-3 mb-3">
                                    <h4 className="text-success fw-bold">{formatCurrency(total, currency)}</h4>
                                </div>
                            </div>
                        </div>:
                        <>
                        {!isVip && (user_total>=limit_total) ?
                        <div className="d-text">
                            <div className="small-text text-center">
                                {lang==='pt' &&<p><strong>Capacidade máxima atingida.</strong><br />Se tiver interesse em ser incluído na lista de espera, favor enviar e-mail para <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>}
                                {lang==='es' &&<p><strong>Inscripciones cerradas.</strong><br />Si tiene interés en ser incluido en la lista de espera, por favor envíe un correo electrónico a <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>}
                                {lang==='en' &&<p><strong>Fully booked.</strong><br />If you wish to be included on the waiting list, please send an email to <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>}
                            </div>
                        </div>:
                        <>
                            {user_total>=limit_total_vip ?
                            <div className="d-text">
                                <div className="small-text text-center">
                                    {lang==='pt' &&<p><strong>Capacidade máxima atingida.</strong><br />Se tiver interesse em ser incluído na lista de espera, favor enviar e-mail para <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>}
                                    {lang==='es' &&<p><strong>Inscripciones cerradas.</strong><br />Si tiene interés en ser incluido en la lista de espera, por favor envíe un correo electrónico a <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>}
                                    {lang==='en' &&<p><strong>Fully booked.</strong><br />If you wish to be included on the waiting list, please send an email to <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></p>}
                                </div>
                            </div>:
                            <>
                            {page===0 &&
                                <div className="d-big-text">
                                    <table className="w-100">
                                        <tbody>
                                            <tr>
                                                <td colSpan="3">
                                                    {lang==='pt' &&<p><strong>Seminários clínicos pré-conferência estarão disponíveis na quarta-feira, 29 de julho de 2026, das 19:30 às 21:30, para os inscritos na conferência principal, mediante uma taxa adicional. Todas as outras atividades de quarta-feira, 29 de julho, são gratuitas para todos os participantes da conferência.</strong></p>}
                                                    {lang==='pt' &&<p><strong>Taxas dos seminários clínicos pré-conferência:</strong></p>}

                                                    {lang==='es' &&<p><strong>Los seminarios clínicos preconferencia estarán disponibles el miércoles 29 de julio de 2026, entre las 19:30 y las 21:30, para los inscritos en la conferencia principal, por un costo adicional. Todas las demás actividades del miércoles 29 de julio son gratuitas para todos los participantes de la conferencia.</strong></p>}
                                                    {lang==='es' &&<p><strong>Tarifas de los seminarios clínicos pre-conferencia:</strong></p>}

                                                    {lang==='en' &&<p><strong>Pre-Conference clinical seminars are available on Wednesday, July 29, 2026, between 19:30-21:30 for registrants to the main conference, for an additional fee. All other activities on Wednesday, July 29 are for free for all participants to the conference.</strong></p>}
                                                    {lang==='en' &&<p><strong>Pre-conference clinical seminars fees:</strong></p>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="3">
                                                    {lang==='pt' &&<p>
                                                        * Membros do FTMT: <strong>€ 27.00</strong><br />
                                                        * Não Membros: <strong>€ 30.00</strong><br />
                                                        * Para residentes no Brasil: <strong>R$ 190,00</strong>
                                                    </p>}

                                                    {lang==='es' &&<p>
                                                        * Miembros del FTMT: <strong>€ 27.00</strong><br />
                                                        * No Miembros: <strong>€ 30.00</strong><br />
                                                        * Para residentes en Brasil: <strong>R$ 190,00</strong>
                                                    </p>}

                                                    {lang==='en' &&<p>
                                                        * FTMT Members: <strong>€ 27.00</strong><br />
                                                        * Non-Members: <strong>€ 30.00</strong><br />
                                                        * For residents in Brazil: <strong>R$ 190,00</strong>
                                                    </p>}
                                                    <p>&nbsp;</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                {lang==='pt' &&
                                                <td colSpan="3">
                                                    <p><strong>Categorias e Preços da Conferência Principal</strong></p>
                                                    <p>A precificação para a Conferência Principal é estruturada por categoria de Membros do FTMT - Frances Tustin Memorial Trust e não membros, residência geográfica dos participantes e prazo de inscrição: antecipada até 15 de abril.</p>
                                                    <p className="text-blue"><strong>Devido à capacidade limitada do local, encorajamos que você se inscreva o mais breve possível para garantir sua participação.</strong></p>
                                                    <p>&nbsp;</p>
                                                </td>}
                                                {lang==='es' &&
                                                <td colSpan="3">
                                                    <p><strong>Categorías y Precios de la Conferencia Principal</strong></p>
                                                    <p>Los precios para la Conferencia Principal se estructuran por categoría de Miembros del FTMT - Frances Tustin Memorial Trust y no miembros, residencia geográfica de los participantes y fecha límite de inscripción: anticipada hasta el 15 de abril.</p>
                                                    <p className="text-blue"><strong>Debido a la capacidad limitada de la sede, le recomendamos inscribirse lo antes posible para asegurar su participación.</strong></p>
                                                    <p className="py-1 fw-semibold text-left">
                                                        ⚠️ Si un número considerable de personas prefiere tener un seminario clínico durante la conferencia en español, organizaremos dicha opción. Si alguien está interesado en esta alternativa, por favor contáctenos por correo electrónico a: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a>
                                                    </p>
                                                    <p>&nbsp;</p>
                                                </td>}
                                                {lang==='en' &&
                                                <td colSpan="3">
                                                    <p><strong>Main Conference Categories &amp; Pricing</strong></p>
                                                    <p>Pricing for the Main Conference is structured by category of FTMT - Frances Tustin Memorial Trust Members and non-members, geographic residence of participants and on registration deadline: early bird until 15th of April.</p>
                                                    <p className="text-blue"><strong>Due to the limited capacity of the venue we encourage you to register as soon as possible so as to secure your participation.</strong></p>
                                                    <p>&nbsp;</p>
                                                </td>}
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p>&nbsp;</p>
                                                </td>
                                                <td>
                                                    {lang==='pt' &&<p>Inscrição Antecipada até 15 de abril</p>}
                                                    {lang==='es' &&<p>Inscripción Anticipada hasta el 15 de abril</p>}
                                                    {lang==='en' &&<p>Early Bird until 15<sup>th</sup> of April</p>}
                                                </td>
                                                <td>
                                                    {lang==='pt' &&<p>Inscrição Tardia até 30 de junho</p>}
                                                    {lang==='es' &&<p>Inscripción Tardía hasta el 30 de junio</p>}
                                                    {lang==='en' &&<p>Late Registration until June 30th</p>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {lang==='pt' &&<p>Membros do FTMT da América Latina* / Leste Europeu / Índia**</p>}
                                                    {lang==='es' &&<p>Miembros del FTMT de América Latina* / Europa del Este / India**</p>}
                                                    {lang==='en' &&<p>FTMT Members from Latin America* / Eastern Europe / India**</p>}
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 215.00</strong></p>
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 275.00</strong></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {lang==='pt' &&<p>Membros do FTMT residentes no Brasil</p>}
                                                    {lang==='es' &&<p>Miembros del FTMT residentes en Brasil</p>}
                                                    {lang==='en' &&<p>FTMT Members residents in Brazil</p>}
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>R$ 1.375,00</strong></p>
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>R$ 1.630,00</strong></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {lang==='pt' &&<p>Membros do FTMT de outros países</p>}
                                                    {lang==='es' &&<p>Miembros del FTMT de otros países</p>}
                                                    {lang==='en' &&<p>FTMT Members from any other countries</p>}
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 290.00</strong></p>
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 350.00</strong></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {lang==='pt' &&<p>Não Membros da América Latina* / Leste Europeu / Índia**</p>}
                                                    {lang==='es' &&<p>No Miembros de América Latina* / Europa del Este / India**</p>}
                                                    {lang==='en' &&<p>Non-Members from Latin America* / Eastern Europe / India**</p>}
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 240.00</strong></p>
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 300.00</strong></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {lang==='pt' &&<p>Não Membros residentes no Brasil</p>}
                                                    {lang==='es' &&<p>No Miembros residentes en Brasil</p>}
                                                    {lang==='en' &&<p>Non-Members residents in Brazil</p>}
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>R$ 1.530,00</strong></p>
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>R$ 1.780,00</strong></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {lang==='pt' &&<p>Não Membros de outros países</p>}
                                                    {lang==='es' &&<p>No Miembros de otros países</p>}
                                                    {lang==='en' &&<p>Non-Members from any other countries</p>}
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 320.00</strong></p>
                                                </td>
                                                <td width="120" className="text-end">
                                                    <p><strong>€ 390.00</strong></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="3">
                                                    {lang==='pt' &&<p><small><strong>*Países da América Latina:</strong> Argentina, Bolívia, Brasil, Chile, Colômbia, Costa Rica, Cuba, Equador, El Salvador, Guatemala, Haiti, Honduras, México, Nicarágua, Panamá, Paraguai, Peru, República Dominicana, Uruguai, Venezuela.</small></p>}
                                                    {lang==='pt' &&<p className="mb-0"><small><strong>**Países do Leste Europeu:</strong> Albânia, Bielorrússia, Bósnia e Herzegovina, Bulgária, Croácia, República Tcheca, Estônia, Hungria, Lituânia, Letônia, Macedônia, Moldávia, Montenegro, Polônia, Romênia, Rússia, Sérvia, Eslováquia, Eslovênia, Turquia, Ucrânia.</small></p>}

                                                    {lang==='es' &&<p><small><strong>*Países de América Latina:</strong> Argentina, Bolivia, Brasil, Chile, Colombia, Costa Rica, Cuba, Ecuador, El Salvador, Guatemala, Haití, Honduras, México, Nicaragua, Panamá, Paraguay, Perú, República Dominicana, Uruguay, Venezuela.</small></p>}
                                                    {lang==='es' &&<p className="mb-0"><small><strong>**Países de Europa del Este:</strong> Albania, Bielorrusia, Bosnia y Herzegovina, Bulgaria, Croacia, República Checa, Estonia, Hungría, Lituania, Letonia, Macedonia, Moldavia, Montenegro, Polonia, Rumania, Rusia, Serbia, Eslovaquia, Eslovenia, Turquía, Ucrania.</small></p>}

                                                    {lang==='en' &&<p><small><strong>*Latin America countries:</strong> Argentina, Bolívia, Brasil, Chile, Colômbia, Costa Rica, Cuba, Equador, El Salvador, Guatemala, Haiti, Honduras, México, Nicarágua, Panamá, Paraguai, Peru, República Dominicana, Uruguai, Venezuela.</small></p>}
                                                    {lang==='en' &&<p className="mb-0"><small><strong>**Eastern Europe countries:</strong> Albania, Belarus, Bosnia and Herzegovina, Bulgaria, Croatia, Czech Republic, Estonia, Hungary, Lithuania, Latvia, Macedonia, Moldova, Montenegro, Poland, Romania, Russia, Serbia, Slovakia, Slovenia, Turkey, Ukraine.</small></p>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p className="mt-2"><strong>{lang==='pt' ? 'Jantar Festivo (com música e dança)' : lang==='es' ? 'Cena Festiva (con música y baile)' : 'Festive Dinner (with music and dance)'}</strong></p>
                                                </td>
                                                <td colSpan="2">
                                                    <p className="mt-5 text-end">
                                                        <strong>€ 65.00</strong><br />
                                                        <strong>R$ 380,00</strong><br />({lang==='pt' ? 'para residentes no Brasil' : lang==='es' ? 'para residentes en Brasil' : 'for residents in Brazil'})
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>}

                                {page===1 &&
                                <>
                                    <div className="d-text">
                                        {lang==='pt' &&<p className="mb-0">Preencha sua inscrição para o <strong>10th Frances Tustin International Conference</strong> que ocorrerá em São Paulo, de 29 de Julho à 01 de Agosto de 2026.</p>}
                                        {lang==='es' &&<p className="mb-0">Complete su formulario de inscripción para la <strong>10th Frances Tustin International Conference</strong>, que tendrá lugar en São Paulo, del 29 de julio al 1 de agosto de 2026.</p>}
                                        {lang==='en' &&<p className="mb-0">Fill out your registration form for the <strong>10th Frances Tustin International Conference</strong>, which will take place in São Paulo, from July 29 to August 1, 2026.</p>}
                                    </div>
                                    <div className="d-input">
                                        <label>{language.name}: <span>*</span></label>
                                        <input type="text" ref={nameInput} value={name} onChange={e => {setName(e.target.value);clearMessage();}} />
                                    </div>
                                    <div className="d-input">
                                        <label>{language.name_badge}: <span>*</span></label>
                                        <input type="text" ref={nameBadgeInput} value={name_badge} onChange={e => {setNameBadge(e.target.value);clearMessage();}} />
                                    </div>
                                    <div className="d-input">
                                        <label>{language.email}: <span>*</span></label>
                                        <input type="email" ref={emailInput} value={email} onChange={e => {setEmail(e.target.value);clearMessage();}} />
                                    </div>
                                    <div className="d-select">
                                        <label>{language.country}: <span>*</span></label>
                                        <select
                                            ref={countryInput}
                                            value={country}
                                            onChange={(e) => {
                                                const selectedCode = e.target.value;
                                                setCountry(selectedCode);
                                                clearMessage();
                                                const selectedCountry = countries.find((item) => item.codigo === selectedCode);
                                                if (selectedCountry) {
                                                    changePhoneCountry(selectedCountry.codigo_phone);
                                                }
                                            }}
                                        >
                                            <option value="">{lang==='pt' ? 'Selecione um país' : lang==='es' ? 'Seleccione un país' : 'Select a country'}</option>
                                            {countries.map(country => (
                                            <option key={country.codigo} value={country.codigo}>
                                                {lang === 'pt' ? country.nome : lang === 'es' ? country.nome_es : country.nome_en}
                                            </option>))}
                                        </select>
                                    </div>
                                    <div className="d-input">
                                        <label>{language.phone}: <span>*</span></label>
                                        <PhoneInput className="d-phone-input" defaultCountry={phone_country} hideDropdown ref={phoneInput} value={phone} onChange={phone => {setPhone(phone);clearMessage();}} />
                                    </div>
                                    <div className="d-input">
                                        <label>{(category==='2' || category==='5' || country==='BRA') ? language.cpf : language.id}: <span>*</span></label>
                                        {(category==='2' || category==='5' || country==='BRA') ?
                                        <InputMask mask="999.999.999-99" inputRef={documentInput} value={document} onChange={e => {changeValidateCPF(e.target.value);clearMessage();}} type="tel" />:
                                        <input type="text" ref={documentInput} value={document} onChange={e => {setDocument(e.target.value);clearMessage();}} />}
                                    </div>
                                    <div className="d-select">
                                        <label>{lang==='pt' ? 'Categoria' : lang==='es' ? 'Categoría' : 'Category'}: <span>*</span></label>
                                        <select ref={categoryInput} value={category} onChange={e => {changeCategory(e.target.value);clearMessage();}}>
                                            <option value="">{lang==='pt' ? 'Selecione uma categoria' : lang==='es' ? 'Seleccione una categoría' : 'Select a category'}</option>
                                            <option value="0">{lang==='pt' ? 'Membros do Conselho do Tustin Trust, Membros da Comissão Organizadora Brasileira, Palestrantes e Supervisores de Seminários Clínicos (Gratuito)' : lang==='es' ? 'Miembros del Consejo del Tustin Trust, Miembros del Comité Organizador Brasileño, Conferencistas y Supervisores de Seminarios (Gratis)' : 'Tustin Trust Board Members, Members of the Brazilian Organizational Committee, Lecturers and Supervisors of Clinical Seminars (Free)'}</option>
                                            <option value="1">{lang==='pt' ? 'Membros do FTMT da América Latina* / Leste Europeu / Índia**' : lang==='es' ? 'Miembros del FTMT de América Latina* / Europa del Este / India**' : 'FTMT Members from Latin America** / Eastern Europe / India**'} (€ 275.00)</option>
                                            <option value="2">{lang==='pt' ? 'Membros do FTMT residentes no Brasil' : lang==='es' ? 'Miembros del FTMT residentes en Brasil' : 'FTMT Members residents in Brazil'} (R$ 1.630,00)</option>
                                            <option value="3">{lang==='pt' ? 'Membros do FTMT de outros países' : lang==='es' ? 'Miembros del FTMT de otros países' : 'FTMT Members from any other countries'} (€ 350.00)</option>
                                            <option value="4">{lang==='pt' ? 'Não Membros da América Latina* / Leste Europeu / Índia**' : lang==='es' ? 'No Miembros de América Latina* / Europa del Este / India**' : 'Non-Members from Latin America** / Eastern Europe / India**'} (€ 300.00)</option>
                                            <option value="5">{lang==='pt' ? 'Não Membros residentes no Brasil' : lang==='es' ? 'No Miembros residentes en Brasil' : 'Non-Members residents in Brazil'} (R$ 1.780,00)</option>
                                            <option value="6">{lang==='pt' ? 'Não Membros de outros países' : lang==='es' ? 'No Miembros de otros países' : 'Non-Members from any other countries'} (€ 390.00)</option>
                                        </select>
                                        <div className="d-text d-text-small mt-2 mb-0">
                                            <p><small>{lang==='pt' ? 'Membros do FTMT" refere-se aos membros do Memorial Frances Tustin' : lang==='es' ? 'Miembros del FTMT" se refiere a los miembros del Memorial Frances Tustin' : 'Members of FTMT\' refers to the members of the Frances Tustin Memorial Trust.'}</small></p>
                                        </div>
                                    </div>
                                    {category==='0' &&
                                    <div className="d-select">
                                        <label>{lang==='pt' ? 'Membro da Fundação Frances Tustin' : lang==='es' ? 'Miembro del Frances Tustin' : 'Frances Tustin Member'}: <span>*</span></label>
                                        <select value={member_tustin} onChange={e => {setMemberTustin(e.target.value);clearMessage();}}>
                                            <option value="yes">{lang==='pt' ? 'Sim' : lang==='es' ? 'Sí' : 'Yes'}</option>
                                            <option value="no">{lang==='pt' ? 'Não' : lang==='es' ? 'No' : 'No'}</option>
                                        </select>
                                    </div>}
                                    <div className="d-text d-text-small mt-2 mb-0">
                                        {lang==='pt' &&<p><small><strong>*Países da América Latina:</strong> Argentina, Bolívia, Brasil, Chile, Colômbia, Costa Rica, Cuba, Equador, El Salvador, Guatemala, Haiti, Honduras, México, Nicarágua, Panamá, Paraguai, Peru, República Dominicana, Uruguai, Venezuela.</small></p>}
                                        {lang==='pt' &&<p className="mb-0"><small><strong>**Países do Leste Europeu:</strong> Albânia, Bielorrússia, Bósnia e Herzegovina, Bulgária, Croácia, República Tcheca, Estônia, Hungria, Lituânia, Letônia, Macedônia, Moldávia, Montenegro, Polônia, Romênia, Rússia, Sérvia, Eslováquia, Eslovênia, Turquia, Ucrânia.</small></p>}

                                        {lang==='es' &&<p><small><strong>*Países de América Latina:</strong> Argentina, Bolivia, Brasil, Chile, Colombia, Costa Rica, Cuba, Ecuador, El Salvador, Guatemala, Haití, Honduras, México, Nicaragua, Panamá, Paraguay, Perú, República Dominicana, Uruguay, Venezuela.</small></p>}
                                        {lang==='es' &&<p className="mb-0"><small><strong>**Países de Europa del Este:</strong> Albania, Bielorrusia, Bosnia y Herzegovina, Bulgaria, Croacia, República Checa, Estonia, Hungría, Lituania, Letonia, Macedonia, Moldavia, Montenegro, Polonia, Rumania, Rusia, Serbia, Eslovaquia, Eslovenia, Turquía, Ucrania.</small></p>}

                                        {lang==='en' &&<p><small><strong>*Latin America countries:</strong> Argentina, Bolívia, Brasil, Chile, Colômbia, Costa Rica, Cuba, Equador, El Salvador, Guatemala, Haiti, Honduras, México, Nicarágua, Panamá, Paraguai, Peru, República Dominicana, Uruguai, Venezuela.</small></p>}
                                        {lang==='en' &&<p className="mb-0"><small><strong>**Eastern Europe countries:</strong> Albania, Belarus, Bosnia and Herzegovina, Bulgaria, Croatia, Czech Republic, Estonia, Hungary, Lithuania, Latvia, Macedonia, Moldova, Montenegro, Poland, Romania, Russia, Serbia, Slovakia, Slovenia, Turkey, Ukraine.</small></p>}
                                    </div>
                                </>}
                                
                                {page===2 &&
                                <>
                                    <div className="d-select">
                                        {lang==='pt' &&<label>Gostaria de participar de um seminário clínico pré-conferência na quarta-feira, 29/07/2026?</label>}
                                        {lang==='es' &&<label>Le gustaría participar en un seminario clínico pre-conferencia el miércoles 29/07/2026?</label>}
                                        {lang==='en' &&<label>Would you like to participate in a pre-conference clinical seminar on Wednesday, 29.7.2026?</label>}
                                        <select
                                            value={pre_conference}
                                            onChange={e => {changePreConference(e.target.value);clearMessage();}}
                                        >
                                            <option value="yes">{lang==='pt' ? 'Sim' : lang==='es' ? 'Sí' : 'Yes'}</option>
                                            <option value="no">{lang==='pt' ? 'Não' : lang==='es' ? 'No' : 'No'}</option>
                                        </select>
                                    </div>
                                    {pre_conference=='yes' &&
                                    <>
                                        {category==='0' &&
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Membro da FTMT' : lang==='pt' ? 'Miembro del FTMT' : 'FTMT Member'}: <span>*</span></label>
                                            <select value={member} onChange={e => {setMember(e.target.value);clearMessage();}}>
                                                <option value="yes">{lang==='pt' ? 'Sim' : lang==='es' ? 'Sí' : 'Yes'}</option>
                                                <option value="no">{lang==='pt' ? 'Não' : lang==='es' ? 'No' : 'No'}</option>
                                            </select>
                                        </div>}
                                        <div className="d-text">
                                            {lang==='pt' &&<p>A inscrição para os seminários clínicos pré-conferência só será aceita se você também se inscrever na conferência principal.</p>}
                                            {lang==='pt' &&<p>Antes da inscrição para os seminários clínicos pré-conferência que acontecem na quarta-feira, 29 de julho de 2026, entre 19:30 e 21:30, por favor verifique a seguinte lista de seminários clínicos e selecione 3 preferências:</p>}

                                            {lang==='es' &&<p>La inscripción a los seminarios clínicos pre-conferencia solo será aceptada si también se inscribe en la conferencia principal.</p>}
                                            {lang==='es' &&<p>Antes de la inscripción para los seminarios clínicos pre-conferencia que tienen lugar el miércoles 29 de julio de 2026 entre las 19:30 y las 21:30, por favor revise la siguiente lista de seminarios clínicos y seleccione 3 preferencias:</p>}

                                            {lang==='en' &&<p>Registration to preconference clinical seminars will only be accepted if you register in the main conference as well.</p>}
                                            {lang==='en' &&<p>Before the registration for the Pre-conference clinical seminars that take place on Wednesday, July 29, 2026 between 19:30-21:30 please check the following list of clinical seminars and select 3 preferences:</p>}

                                            <p className="mb-0">
                                                <strong>Dr. Vera Regina Fonseca</strong> (Brazil) - in English - child or adult case <br />
                                                <strong>Alícia Beatriz Dorado de Lisondo</strong> (Brazil) - in Spanish with help in Portuguese - child case <br />
                                                <strong>Dr. Jeanne Magagna</strong> (UK) - in English - child case <br />
                                                <strong>Dr. Chiara Cattelan</strong> (Italy) - in English - autistic child case<br />
                                                <strong>Dr. Nilofer Kaul</strong> (India) - in English - adult case<br />
                                                <strong>Alina Schellekes</strong> (Israel) - in English - adult case<br /><br />
                                                <strong>{lang==='pt' ? 'Por favor, escolha três preferências' : lang==='es' ? 'Por favor, elija tres preferencias' : 'Please choose three preferences'}:</strong>
                                            </p>
                                        </div>
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Preferência 1' : lang==='es' ? 'Preferencia 1' : 'Preference 1'}: <span>*</span></label>
                                            <select ref={prePrefer1Input} value={pre_prefer_1} onChange={e => {setPrePrefer1(e.target.value);clearMessage();}}>
                                                <option value="">{lang==='pt' ? 'Selecione uma preferência' : lang==='es' ? 'Seleccione una preferencia' : 'Select a preference'}</option>
                                                <option value="1">Dr. Vera Regina Fonseca (Brazil) - in English - child or adult case</option>
                                                <option value="2">Alícia Beatriz Dorado de Lisondo (Brazil) - in Spanish with help in Portuguese - child case</option>
                                                <option value="3">Dr. Jeanne Magagna (UK) - in English - child case</option>
                                                <option value="4">Dr. Chiara Cattelan (Italy) - in English - autistic child case</option>
                                                <option value="5">Dr. Nilofer Kaul (India) - in English - adult case</option>
                                                <option value="6">Alina Schellekes (Israel) - in English - adult case</option>
                                            </select>
                                        </div>
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Preferência 2' : lang==='es' ? 'Preferencia 2' : 'Preference 2'}: <span>*</span></label>
                                            <select ref={prePrefer2Input} value={pre_prefer_2} onChange={e => {setPrePrefer2(e.target.value);clearMessage();}}>
                                                <option value="">{lang==='pt' ? 'Selecione uma preferência' : lang==='es' ? 'Seleccione una preferencia' : 'Select a preference'}</option>
                                                <option value="1">Dr. Vera Regina Fonseca (Brazil) - in English - child or adult case</option>
                                                <option value="2">Alícia Beatriz Dorado de Lisondo (Brazil) - in Spanish with help in Portuguese - child case</option>
                                                <option value="3">Dr. Jeanne Magagna (UK) - in English - child case</option>
                                                <option value="4">Dr. Chiara Cattelan (Italy) - in English - autistic child case</option>
                                                <option value="5">Dr. Nilofer Kaul (India) - in English - adult case</option>
                                                <option value="6">Alina Schellekes (Israel) - in English - adult case</option>
                                            </select>
                                        </div>
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Preferência 3' : lang==='es' ? 'Preferencia 3' : 'Preference 3'}: <span>*</span></label>
                                            <select ref={prePrefer3Input} value={pre_prefer_3} onChange={e => {setPrePrefer3(e.target.value);clearMessage();}}>
                                                <option value="">{lang==='pt' ? 'Selecione uma preferência' : lang==='es' ? 'Seleccione una preferencia' : 'Select a preference'}</option>
                                                <option value="1">Dr. Vera Regina Fonseca (Brazil) - in English - child or adult case</option>
                                                <option value="2">Alícia Beatriz Dorado de Lisondo (Brazil) - in Spanish with help in Portuguese - child case</option>
                                                <option value="3">Dr. Jeanne Magagna (UK) - in English - child case</option>
                                                <option value="4">Dr. Chiara Cattelan (Italy) - in English - autistic child case</option>
                                                <option value="5">Dr. Nilofer Kaul (India) - in English - adult case</option>
                                                <option value="6">Alina Schellekes (Israel) - in English - adult case</option>
                                            </select>
                                        </div>
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Por favor, indique se deseja apresentar um caso clínico' : lang==='es' ? 'Por favor, indique si desea presentar un caso clínico' : 'Please mention if you wish to present a clinical case'}:</label>
                                            <select value={case_pre_opt} onChange={e => {setCasePreOpt(e.target.value);clearMessage();}}>
                                                <option value="yes">{lang==='pt' ? 'Sim' : lang==='es' ? 'Sí' : 'Yes'}</option>
                                                <option value="no">{lang==='pt' ? 'Não' : lang==='es' ? 'No' : 'No'}</option>
                                            </select>
                                        </div>
                                        {case_pre_opt=='yes' &&
                                        <>
                                            <div className="d-select">
                                                <label>{lang==='pt' ? 'Opções' : lang==='es' ? 'Opciones' : 'Options'}: <span>*</span></label>
                                                <select ref={casePreTypeInput} value={case_pre_type} onChange={e => {setCasePreType(e.target.value);clearMessage();}}>
                                                    <option value="">{lang==='pt' ? 'Selecione uma opção' : lang==='es' ? 'Seleccione una opción' : 'Select an option'}</option>
                                                    <option value="1">{lang==='pt' ? 'Caso pediátrico' : lang==='es' ? 'Caso de niño' : 'Child case'}</option>
                                                    <option value="2">{lang==='pt' ? 'Caso adulto' : lang==='es' ? 'Caso de adulto' : 'Adult case'}</option>
                                                </select>
                                            </div>
                                            <div className="d-text">
                                                <p className="mb-0">
                                                    {lang === 'pt'
                                                    ? <>Quem desejar submeter material clínico deve enviar um breve resumo de até 750 palavras (cerca de uma página e meia) e a descrição detalhada de duas sessões consecutivas. <strong>O prazo para submissão de casos é 30 de abril</strong>. Envie seu material para o seguinte endereço de e-mail: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></>
                                                    : lang === 'es'
                                                    ? <>Quien desee enviar material clínico debe enviar un breve historial de hasta 750 palabras (alrededor de una página a una página y media) y dos sesiones detalladas consecutivas. <strong>La fecha límite para el envío del caso es el 30 de abril</strong>. Por favor, envíe su material a la siguiente dirección de correo electrónico: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></>
                                                    : <>Anyone wishing to submit clinical material must send a short background of up to 750 words (around one-one and a half pages) and two detailed consecutive sessions. <strong>The case submission deadline is April 30th</strong>. Please send your material to the following email address: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></>}
                                                </p>
                                            </div>
                                        </>}
                                    </>}
                                </>}

                                {page===3 &&
                                <>
                                    <div className="d-text">
                                        <p>
                                            {lang==='pt'
                                            ? 'Por favor, escolha suas 3 preferências para os seminários clínicos durante a conferência principal, que acontecem na sexta-feira, 31 de julho. Estes seminários fazem parte da conferência e estão incluídos na taxa de inscrição da conferência.'
                                            : lang==='es'
                                            ? 'Por favor, seleccione sus tres seminarios clínicos preferidos durante la conferencia principal, que tendrá lugar el viernes 31 de julio. Estos seminarios son parte de la conferencia y están incluidos en la tarifa de inscripción de la conferencia.'
                                            : 'Please select your three preferred clinical seminars during the main conference, which will take place on Friday, July 31. These seminars are part of the conference and are included in the conference registration fee.'}
                                        </p>
                                        <p className="mb-0">
                                            <strong className="text-blue">{lang==='pt' ? 'Inscrição para seminários clínicos na sexta-feira, 31 de julho' : lang==='es' ? 'Inscripción para seminarios clínicos el viernes 31 de julio' : 'Registration for clinical seminars on Friday, July 31'}</strong><br /><br />
                                            <strong>Prof. Didier Houzel</strong> (France) - child case (preferably autistic spectrum) - English<br />
                                            <strong>Alina Schellekes</strong> (Israel) - adult case - English<br />
                                            <strong>Dr. Nilofer Kaul</strong> (India) - adult case - English<br />
                                            <strong>Joel Miller</strong> (Israel) - child or adult case - English<br />
                                            <strong>Célia Fix Korbivcher</strong> (Brazil) - adult case - Portuguese<br />
                                            <strong>Paulo Duarte Guimarães Filho</strong> (Brazil) - autistic child - English <br />
                                            <strong>Micky Bhatia</strong> (India) - adult case - English <br />
                                            <strong>Dr. Mariângela Mendes de Almeida</strong> (Prisma - Brazil) - Clinical workshop: Building up a prismatic profile of psychic functioning: autistic interfaces - child case - Portuguese/Spanish <br />
                                            <strong>Prof. Alícia Beatriz Dorado de Lisondo and Dr. Regina Elisabeth Lordello Coimbra</strong> (Brazil) - Discussion of a case from a  psychoanalytic socio-educational approach, as practiced in Instituto Çarê/Acaia (São Paulo) - Portuguese/Spanish<br /><br />
                                            <strong>{lang==='pt' ? 'Por favor, escolha três preferências' : lang==='es' ? 'Por favor, elija tres preferencias' : 'Please choose three preferences'}:</strong>
                                        </p>
                                    </div>
                                    <div className="d-select">
                                        <label>{lang==='pt' ? 'Preferência 1' : lang==='es' ? 'Preferencia 1' : 'Preference 1'}: <span>*</span></label>
                                        <select ref={prefer1Input} value={prefer_1} onChange={e => {setPrefer1(e.target.value);clearMessage();}}>
                                            <option value="">{lang==='pt' ? 'Selecione uma preferência' : lang==='es' ? 'Seleccione una preferencia' : 'Select a preference'}</option>
                                            <option value="1">Prof. Didier Houzel (France) - in English - child case (preferably autistic spectrum)</option>
                                            <option value="3">Alina Schellekes (Israel) - in English - adult case</option>
                                            <option value="4">Dr. Nilofer Kaul (India) - in English - adult case</option>
                                            <option value="5">Joel Miller (Israel) - in English - child or adult case</option>
                                            <option value="6">Célia Fix Korbivcher (Brazil) - in Portuguese - adult case</option>
                                            <option value="7">Paulo Duarte Guimarães Filho (Brazil) - in English - autistic child</option>
                                            <option value="8">Micky Bhatia (India) - in English - adult case </option>
                                            <option value="9">Dr. Mariângela Mendes de Almeida (Prisma - Brazil) - in Portuguese/Spanish - Clinical workshop: Building up a prismatic profile of psychic functioning: autistic interfaces - child case</option>
                                            <option value="10">Prof. Alícia Beatriz Dorado de Lisondo and Dr. Regina Elisabeth Lordello Coimbra (Brazil) - Discussion of a case from a  psychoanalytic socio-educational approach, as practiced in Instituto Çarê/Acaia (São Paulo) - Portuguese/Spanish</option>
                                        </select>
                                    </div>
                                    <div className="d-select">
                                        <label>{lang==='pt' ? 'Preferência 2' : lang==='es' ? 'Preferencia 2' : 'Preference 2'}: <span>*</span></label>
                                        <select ref={prefer2Input} value={prefer_2} onChange={e => {setPrefer2(e.target.value);clearMessage();}}>
                                            <option value="">{lang==='pt' ? 'Selecione uma preferência' : lang==='es' ? 'Seleccione una preferencia' : 'Select a preference'}</option>
                                            <option value="1">Prof. Didier Houzel (France) - in English - child case (preferably autistic spectrum)</option>
                                            <option value="3">Alina Schellekes (Israel) - in English - adult case</option>
                                            <option value="4">Dr. Nilofer Kaul (India) - in English - adult case</option>
                                            <option value="5">Joel Miller (Israel) - in English - child or adult case</option>
                                            <option value="6">Célia Fix Korbivcher (Brazil) - in Portuguese - adult case</option>
                                            <option value="7">Paulo Duarte Guimarães Filho (Brazil) - in English - autistic child</option>
                                            <option value="8">Micky Bhatia (India) - in English - adult case </option>
                                            <option value="9">Dr. Mariângela Mendes de Almeida (Prisma - Brazil) - in Portuguese/Spanish - Clinical workshop: Building up a prismatic profile of psychic functioning: autistic interfaces - child case</option>
                                            <option value="10">Prof. Alícia Beatriz Dorado de Lisondo and Dr. Regina Elisabeth Lordello Coimbra (Brazil) - Discussion of a case from a  psychoanalytic socio-educational approach, as practiced in Instituto Çarê/Acaia (São Paulo) - Portuguese/Spanish</option>
                                        </select>
                                    </div>
                                    <div className="d-select">
                                        <label>{lang==='pt' ? 'Preferência 3' : lang==='es' ? 'Preferencia 3' : 'Preference 3'}: <span>*</span></label>
                                        <select ref={prefer3Input} value={prefer_3} onChange={e => {setPrefer3(e.target.value);clearMessage();}}>
                                            <option value="">{lang==='pt' ? 'Selecione uma preferência' : lang==='es' ? 'Seleccione una preferencia' : 'Select a preference'}</option>
                                            <option value="1">Prof. Didier Houzel (France) - in English - child case (preferably autistic spectrum)</option>
                                            <option value="3">Alina Schellekes (Israel) - in English - adult case</option>
                                            <option value="4">Dr. Nilofer Kaul (India) - in English - adult case</option>
                                            <option value="5">Joel Miller (Israel) - in English - child or adult case</option>
                                            <option value="6">Célia Fix Korbivcher (Brazil) - in Portuguese - adult case</option>
                                            <option value="7">Paulo Duarte Guimarães Filho (Brazil) - in English - autistic child</option>
                                            <option value="8">Micky Bhatia (India) - in English - adult case </option>
                                            <option value="9">Dr. Mariângela Mendes de Almeida (Prisma - Brazil) - in Portuguese/Spanish - Clinical workshop: Building up a prismatic profile of psychic functioning: autistic interfaces - child case</option>
                                            <option value="10">Prof. Alícia Beatriz Dorado de Lisondo and Dr. Regina Elisabeth Lordello Coimbra (Brazil) - Discussion of a case from a  psychoanalytic socio-educational approach, as practiced in Instituto Çarê/Acaia (São Paulo) - Portuguese/Spanish</option>
                                        </select>
                                    </div>
                                    <div className="d-select">
                                        <label>{lang==='pt' ? 'Por favor, mencione se deseja apresentar um caso clínico em um dos seminários clínicos na sexta-feira, 31/07/2026' : lang==='es' ? 'Por favor, indique si desea presentar un caso clínico en uno de los seminarios clínicos del viernes 31/07/2026' : 'Please mention if you wish to present a clinical case in one of the clinical seminars on Friday, 31.7.2026'}:</label>
                                        <select value={case_opt} onChange={e => {setCaseOpt(e.target.value);clearMessage();}}>
                                            <option value="yes">{lang==='pt' ? 'Sim' : lang==='es' ? 'Sí' : 'Yes'}</option>
                                            <option value="no">{lang==='pt' ? 'Não' : lang==='es' ? 'No' : 'No'}</option>
                                        </select>
                                    </div>
                                    {case_opt=='yes' &&
                                    <>
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Opções' : lang==='es' ? 'Opciones' : 'Options'}: <span>*</span></label>
                                            <select ref={caseTypeInput} value={case_type} onChange={e => {setCaseType(e.target.value);clearMessage();}}>
                                                <option value="">{lang==='pt' ? 'Selecione uma opção' : lang==='es' ? 'Seleccione una opción' : 'Select an option'}</option>
                                                <option value="1">{lang==='pt' ? 'Caso pediátrico' : lang==='es' ? 'Caso de niño' : 'Child case'}</option>
                                                <option value="3">{lang==='pt' ? 'Caso adolescente' : lang==='es' ? 'Caso de adulto' : 'Adolescent case'}</option>
                                                <option value="2">{lang==='pt' ? 'Caso adulto' : lang==='es' ? 'Caso de adolescente' : 'Adult case'}</option>
                                            </select>
                                        </div>
                                        <div className="d-text">
                                            <p className="mb-0">
                                                {lang === 'pt'
                                                ? <>Quem desejar submeter material clínico deve enviar um breve resumo de até 750 palavras (cerca de uma página e meia) e a descrição detalhada de duas sessões consecutivas. Para os seminários 9 e 10, as sessões não precisam ser consecutivas. <strong>O prazo para submissão do material é 30 de abril</strong>. Envie seu material para o seguinte endereço de e-mail: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></>
                                                : lang === 'es'
                                                ? <>Quien desee enviar material clínico debe enviar un breve historial de hasta 750 palabras (alrededor de una página a una página y media) y dos sesiones detalladas consecutivas. Para los seminarios número 9 y 10, las sesiones no necesitan ser consecutivas. <strong>La fecha límite para el envío del material es el 30 de abril</strong>. Por favor, envíe su material a la siguiente dirección de correo electrónico hasta el 30 de abril: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></>
                                                : <>Anyone wishing to submit clinical material must send a short background of up to 750 words (around one-one and a half pages) and two detailed consecutive sessions. For seminars number 9 and 10 the sessions do not need to be consecutive. <strong>The material submission deadline is April 30th</strong>. Please send your material to the following email address till April 30th: <a href="mailto:contato@tustinsaopaulo.org" target="_blank" className="link">contato@tustinsaopaulo.org</a></>}
                                            </p>
                                        </div>
                                    </>}
                                </>}

                                {page===4 &&
                                <>
                                    <div className="d-select">
                                        <label>
                                            {lang === 'pt'
                                            ? 'Deseja participar do jantar festivo na sexta-feira, 31 de julho?'
                                            : lang === 'es'
                                            ? 'Le gustaría participar en la cena festiva el viernes 31 de julio?'
                                            : 'Would you like to participate in the festive dinner on Friday, July 31?'}
                                        </label>
                                        <select
                                            value={dinner}
                                            onChange={e => {setDinner(e.target.value);clearMessage();}}
                                        >
                                            <option value="yes">{lang==='pt' ? 'Sim' : lang==='es' ? 'Sí' : 'Yes'}</option>
                                            <option value="no">{lang==='pt' ? 'Não' : lang==='es' ? 'No' : 'No'}</option>
                                        </select>
                                    </div>
                                    {dinner=='yes' &&
                                    <>
                                        <div className="d-select">
                                            <label>{lang==='pt' ? 'Quantas pessoas' : lang==='es' ? 'Cuántas personas' : 'How many persons'}:</label>
                                            <select value={dinner_person} onChange={e => {setDinnerPerson(e.target.value);clearMessage();}}>
                                                <option value="">{lang==='pt' ? 'Selecione uma opção' : lang==='es' ? 'Seleccione una opción' : 'Select an option'}</option>
                                                <option value="1">{lang==='pt' ? '1 pessoa' : lang==='es' ? '1 persona' : '1 person'}</option>
                                                <option value="2">{lang==='pt' ? '2 pessoas' : lang==='es' ? '2 personas' : '2 people'}</option>
                                            </select>
                                        </div>
                                        {dinner_person=='2' &&
                                        <>
                                            <div className="d-input">
                                                <label>{lang==='pt' ? 'Insira o nome da segunda pessoa' : lang==='es' ? 'Inserte el nombre de la segunda persona' : 'Insert the name of the second person'}: <span>*</span></label>
                                                <input ref={dinnerNameInput} type="text" value={dinner_name} onChange={e => {setDinnerName(e.target.value);clearMessage();}} />
                                            </div>
                                        </>}
                                    </>}
                                </>}

                                {page===5 &&
                                <>
                                    <div className="content-card">
                                        <table className="w-100">
                                            <tbody>
                                                {category==='0' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Membros do Conselho do Tustin Trust, Membros da Comissão Organizadora Brasileira, Palestrantes e Supervisores de Seminários Clínicos</p>}
                                                        {lang==='es' &&<p>Miembros del Consejo del Tustin Trust, Miembros del Comité Organizador Brasileño, Conferencistas y Supervisores de Seminarios Clínicos</p>}
                                                        {lang==='en' &&<p>Tustin Trust Board Members, Members of the Brazilian Organizational Committee, Lecturers and Supervisors of Clinical Seminars</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>{lang==='pt' ? 'Gratuito' : lang==='es' ? 'Gratis' : 'Free'}</strong></p>
                                                    </td>
                                                </tr>}
                                                {category==='1' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Membros do FTMT da América Latina* / Leste Europeu / Índia**</p>}
                                                        {lang==='es' &&<p>Miembros del FTMT de América Latina* / Europa del Este / India**</p>}
                                                        {lang==='en' &&<p>FTMT Members from Latin America* / Eastern Europe / India**</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>€ 275.00</strong></p>
                                                    </td>
                                                </tr>}
                                                {category==='2' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Membros do FTMT residentes no Brasil</p>}
                                                        {lang==='es' &&<p>Miembros del FTMT residentes en Brasil</p>}
                                                        {lang==='en' &&<p>FTMT Members residents in Brazil</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>R$ 1.630,00</strong></p>
                                                    </td>
                                                </tr>}
                                                {category==='3' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Membros do FTMT de outros países</p>}
                                                        {lang==='es' &&<p>Miembros del FTMT de otros países</p>}
                                                        {lang==='en' &&<p>FTMT Members from any other countries</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>€ 350.00</strong></p>
                                                    </td>
                                                </tr>}
                                                {category==='4' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Não Membros da América Latina* / Leste Europeu / Índia**</p>}
                                                        {lang==='es' &&<p>No Miembros de América Latina* / Europa del Este / India**</p>}
                                                        {lang==='en' &&<p>Non-Members from Latin America* / Eastern Europe / India**</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>€ 300.00</strong></p>
                                                    </td>
                                                </tr>}
                                                {category==='5' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Não Membros residentes no Brasil</p>}
                                                        {lang==='es' &&<p>No Miembros residentes en Brasil</p>}
                                                        {lang==='en' &&<p>Non-Members residents in Brazil</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>R$ 1.780,00</strong></p>
                                                    </td>
                                                </tr>}
                                                {category==='6' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Não Membros de outros países</p>}
                                                        {lang==='es' &&<p>No Miembros de otros países</p>}
                                                        {lang==='en' &&<p>Non-Members from any other countries</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>€ 390.00</strong></p>
                                                    </td>
                                                </tr>}
                                                {pre_conference=='yes' &&
                                                <tr>
                                                    <td>
                                                        {lang==='pt' &&<p>Seminário clínico pré-conferência, quarta-feira, 28/07/26, das 19:30 às 21:30.</p>}
                                                        {lang==='es' &&<p>Seminario clínico preconferencia, miércoles, 28/07/26, entre las 19:30 y las 21:30.</p>}
                                                        {lang==='en' &&<p>Pre-conference clinical seminar, Wednesday, 28.7.26, between 19:30-21:30</p>}
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>{formatCurrency(pre_conference_total, currency)}</strong></p>
                                                    </td>
                                                </tr>}
                                                {dinner=='yes' &&
                                                <tr>
                                                    <td>
                                                        <p>
                                                            {lang==='pt' ? 'Jantar Festivo (com música e dança)' : lang==='es' ? 'Cena Festiva (con música y baile)' : 'Festive Dinner (with music and dance)'} <strong>{dinner_person=='2' ? '2x' : ''}</strong>
                                                            {dinner_person=='2' &&
                                                            <>
                                                                <br />{lang==='pt' ? 'Segunda pessoa' : lang==='es' ? 'Segunda persona' : 'Second person'}: <strong>{dinner_name}</strong>
                                                            </>}
                                                        </p>
                                                    </td>
                                                    <td width="120" className="text-end">
                                                        <p><strong>{formatCurrency(dinner_total, currency)}</strong></p>
                                                    </td>
                                                </tr>}
                                            </tbody>
                                        </table>
                                        {total>0 ?
                                        <>
                                            <div className="d-flex align-items-center justify-content-center text-center mt-3 mb-3">
                                                <h4 className="text-success fw-bold">{formatCurrency(total, currency)}</h4>
                                            </div>
                                            {currency === 'BRL' ?
                                            <>
                                                <CardForm
                                                    cardMonth={card_state.cardMonth}
                                                    cardYear={card_state.cardYear}
                                                    onUpdateState={updateStateValues}
                                                    cardNumberRef={formFieldsRefObj.cardNumber}
                                                    cardHolderRef={formFieldsRefObj.cardHolder}
                                                    cardDateRef={formFieldsRefObj.cardDate}
                                                    onCardInputFocus={onCardFormInputFocus}
                                                    onCardInputBlur={onCardInputBlur}
                                                >
                                                    <Card
                                                        cardNumber={card_state.cardNumber}
                                                        cardHolder={card_state.cardHolder}
                                                        cardMonth={card_state.cardMonth}
                                                        cardYear={card_state.cardYear}
                                                        cardCvv={card_state.cardCvv}
                                                        isCardFlipped={card_state.isCardFlipped}
                                                        currentFocusedElm={currentFocusedElm}
                                                        onCardElementClick={focusFormFieldByKey}
                                                        cardNumberRef={cardElementsRef.cardNumber}
                                                        cardHolderRef={cardElementsRef.cardHolder}
                                                        cardDateRef={cardElementsRef.cardDate}
                                                    ></Card>
                                                </CardForm>
                                                
                                                <div className="mt-10"><strong>Endereço</strong></div>
                                                <div className="card-input text-end">
                                                    <InputMask autoComplete="off" id="cepRef" placeholder="CEP" className="card-input__input" mask="99999-999" value={zipcode} onKeyUp={e => searchZipcode(e.target.value)} onChange={e => zipcodeDigit(e.target.value)} type="tel" />
                                                    <div className="d-flex align-items-center justify-content-between mt-1 text-end">
                                                        {cep_error ? <span className="text-danger">{cep_error_message}</span>:<span></span>}
                                                        <a className="link" target="_blank" href="http://www.buscacep.correios.com.br/sistemas/buscacep/default.cfm">Não sei o CEP</a>
                                                    </div>
                                                </div>
                                                <div className="card-form__row">
                                                    <div className="card-form__col">
                                                        <div className="card-input card-form__group">
                                                            <input placeholder="Endereço" className="card-input__input" value={address} onChange={e => setAddress(e.target.value)} type="text" maxLength="30" />
                                                            <input placeholder="Número" className="card-input__input" value={number} onChange={e => setNumber(e.target.value)} type="text" />
                                                        </div>
                                                        <div className="card-input card-form__group">
                                                            <input placeholder="Complemento" className="card-input__input" value={complement} onChange={e => setComplement(e.target.value)} type="text" maxLength="30" />
                                                            <input placeholder="Bairro" className="card-input__input" value={neighborhood} onChange={e => setNeighborhood(e.target.value)} type="text" />
                                                        </div>
                                                        <div className="card-input card-form__group">
                                                            <input placeholder="Cidade" className="card-input__input" value={city} onChange={e => setCity(e.target.value)} type="text" />
                                                            <select className="card-input__input -select" value={state} onChange={e => setState(e.target.value)}>
                                                                <option value="">Estado</option>
                                                                <option value="AC">Acre</option>
                                                                <option value="AL">Alagoas</option>
                                                                <option value="AP">Amapá</option>
                                                                <option value="AM">Amazonas</option>
                                                                <option value="BA">Bahia</option>
                                                                <option value="CE">Ceará</option>
                                                                <option value="DF">Distrito Federal</option>
                                                                <option value="ES">Espírito Santo</option>
                                                                <option value="GO">Goiás</option>
                                                                <option value="MA">Maranhão</option>
                                                                <option value="MT">Mato Grosso</option>
                                                                <option value="MS">Mato Grosso do Sul</option>
                                                                <option value="MG">Minas Gerais</option>
                                                                <option value="PA">Pará</option>
                                                                <option value="PB">Paraíba</option>
                                                                <option value="PR">Paraná</option>
                                                                <option value="PE">Pernambuco</option>
                                                                <option value="PI">Piauí</option>
                                                                <option value="RJ">Rio de Janeiro</option>
                                                                <option value="RN">Rio Grande do Norte</option>
                                                                <option value="RS">Rio Grande do Sul</option>
                                                                <option value="RO">Rondônia</option>
                                                                <option value="RR">Roraima</option>
                                                                <option value="SC">Santa Catarina</option>
                                                                <option value="SP">São Paulo</option>
                                                                <option value="SE">Sergipe</option>
                                                                <option value="TO">Tocantins</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="alert alert-info mt-2">
                                                    <strong>{lang==='pt' ? 'Atenção' : lang==='es' ? 'Importante' : 'Important'}</strong><br />
                                                    {lang==='pt' ? 'O nome que aparecerá em sua fatura será:' : lang==='es' ? 'El cargo aparecerá en su estado de cuenta a nombre de:' : 'The charge will appear on your statement as:'} <strong>NerdPay</strong>
                                                </div>
                                                <div className="mt-30 mb-0 d-btns w-auto">
                                                    <a href="javascript:;" onClick={() => prev(page)} className="btn-send d-prev bg_color_4">
                                                        <FaArrowLeft />
                                                        <span>{language.prev}</span>
                                                    </a>
                                                    <button type="submit" className={`btn-send d-next bg_color_4 ${ loading ? 'loading' : '' }`}>{language.send} {language.inscricao}</button>
                                                </div>
                                                {loading &&
                                                <div className="row">
                                                    <div className="m-auto text-center">
                                                        <div className="loader-btn mt-4">
                                                            <div className="spinner-content"><div className="bt-spinner mini"></div></div>
                                                            <div className="spinner-text">{language.form_capture}</div>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </>:
                                            <Elements stripe={promise}>
                                                <CheckoutForm
                                                    id={stripeToken}
                                                    price={totalCents}
                                                    name={name}
                                                    email={email}
                                                    phone={phone}
                                                    onPrev={prev}
                                                    onSubmit={sendRegister}
                                                    getId={setStripeId}
                                                />
                                            </Elements>}
                                        </>:
                                        <>
                                            <div className="mt-30 mb-0 d-btns w-auto">
                                                <a href="javascript:;" onClick={() => prev(page)} className="btn-send d-prev bg_color_4">
                                                    <FaArrowLeft />
                                                    <span>{language.prev}</span>
                                                </a>
                                                <button type="submit" className={`btn-send d-next bg_color_4 ${ loading ? 'loading' : '' }`}>{language.send} {language.inscricao}</button>
                                            </div>
                                            {loading &&
                                            <div className="row">
                                                <div className="m-auto text-center">
                                                    <div className="loader-btn mt-4">
                                                        <div className="spinner-content"><div className="bt-spinner mini"></div></div>
                                                        <div className="spinner-text">{language.form_capture}</div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </>}
                                    </div>
                                </>}

                                {error && <div className="d-text mb-0"><div className="error mt-20 mb-20">{error_message}</div></div>}
                                
                                {page<5 &&
                                <div className={`mt-30 mb-40 d-btns ${page==0 ? 'd-btns-first' : ''}`}>
                                    {page>0 && <a href="javascript:;" onClick={() => prev(page)} className="btn-send d-prev bg_color_4">
                                        <FaArrowLeft />
                                        <span>{language.prev}</span>
                                    </a>}
                                    <a href="javascript:;" onClick={() => next(page)} className="btn-send d-next bg_color_4">
                                        <span>{language.next}</span>
                                        <FaArrowRight />
                                    </a>
                                </div>}
                            </>}
                        </>}
                    </>}
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
